// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"userPictureMessage_mainContainer__2ICk4","userImg":"userPictureMessage_userImg__29hCm","messageContainer":"userPictureMessage_messageContainer__2lsNS"};